import { useNavigate, useLocation, To } from 'react-router-dom';

/**
 * A custom navigation hook that persists query parameters across navigations.
 */
export const usePersistentNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  /**
   * Navigates to a new path while preserving the current query string.
   * @param to The destination path or a partial path object.
   * @param options Navigation options (e.g., replace, state).
   */
  const persistentNavigate = (to: To, options?: { replace?: boolean; state?: any }) => {
    const destination = typeof to === 'string'
      ? {
          pathname: to,
          search: location.search, // Append current search string
        }
      : {
          ...to,
          search: to.search || location.search, // Append current search if destination doesn't have one
        };
    navigate(destination, options);
  };

  return persistentNavigate;
};
